var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 20,
    fill: "url(#paint0_linear_193_335)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 35.0996H40V24.0996H24V35.0996ZM33 37.0996V39.0996H37V41.0996H27V39.0996H31V37.0996H23C22.72 37.0996 22.4833 37.0029 22.29 36.8096C22.0967 36.6163 22 36.3796 22 36.0996V23.0996C22 22.8329 22.0967 22.5996 22.29 22.3996C22.4833 22.1996 22.72 22.0996 23 22.0996H41C41.28 22.0996 41.5167 22.1963 41.71 22.3896C41.9033 22.5829 42 22.8196 42 23.0996V36.0996C42 36.3663 41.9033 36.5996 41.71 36.7996C41.5167 36.9996 41.28 37.0996 41 37.0996H33Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_193_335",
    x1: 0,
    y1: 0,
    x2: 64,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22C55E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D9488"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground1);
export default __webpack_public_path__ + "static/media/Background-1.b41620473ce568aa1603ad30206dd576.svg";
export { ForwardRef as ReactComponent };